import { useState } from 'react';
import { useAppState } from 'context/AppState';
import { isRussia } from 'utils/countryCode';
import { isOsrSummarySupportedCrop } from 'pages/RecommendationV2/utils/isOsrSummarySupportedCrop';
import { useTranslation } from 'react-i18next';
import { getCropName } from '../HeroBanner/heroBannerUtils';
import ReportOverviewContent from './ReportOverviewContent';
import { ReportOverviewWrapper, ReportOverviewSection } from './ReportOverview.styles';

interface ReportOverviewProps {
  isLoading: boolean;
}

const ReportOverview = (props: ReportOverviewProps): JSX.Element => {
  const { isLoading } = props;
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [t] = useTranslation();
  const {
    apiData: { recommendationCropwise },
  } = useAppState();

  const handleCollapseChange = (collapsed: boolean) => {
    setIsCollapsed(collapsed);
  };

  const recommendationCW = recommendationCropwise?.recommendations[0];
  const cropName = getCropName(recommendationCW, recommendationCropwise, t);
  const isDDG = recommendationCropwise?.source === 'DDG';
  const isAISummarySupported =
    isOsrSummarySupportedCrop(cropName) && !isRussia(recommendationCropwise?.country) && !isDDG;

  if (isLoading) {
    return <div />;
  }

  return (
    <ReportOverviewWrapper>
      <ReportOverviewSection isAISummarySupported={isAISummarySupported} isCollapsed={isCollapsed}>
        <ReportOverviewContent
          isCollapsed={isCollapsed}
          onCollapseChange={handleCollapseChange}
          isAISummarySupported={isAISummarySupported}
        />
      </ReportOverviewSection>
    </ReportOverviewWrapper>
  );
};

export default ReportOverview;
